// extracted by mini-css-extract-plugin
export var actions = "_25-0";
export var actionsContainer = "_25-7";
export var border = "_25-1";
export var childFullHeight = "_25-f";
export var collapse = "_25-2";
export var content = "_25-a";
export var contentChild = "_25-e";
export var fullscreen = "_25-c";
export var hasLeftRadius = "_25-k";
export var headerContainer = "_25-3";
export var headerRow = "_25-5";
export var hidePadding = "_25-b";
export var navCollapsedGap = "_25-l";
export var noScrollX = "_25-m";
export var noScrollY = "_25-n";
export var noTopPadding = "_25-i";
export var optOutTopPadding = "_25-d";
export var pageMain = "_25-j";
export var pageOuter = "_25-g";
export var pagePadding = "_25-8";
export var pageScroll = "_25-9";
export var profile = "_25-o";
export var profileContainer = "_25-p";
export var profileImage = "_25-q";
export var profileMain = "_25-r";
export var profileSubtitle = "_25-t";
export var profileTitle = "_25-s";
export var showLeftPadding = "_25-h";
export var tabsPortalSlot = "_25-6";
export var tabsWrapper = "_25-4";
export var title = "_25-u";